import "./index.css";
// Buttons to be used in the invoice form
export const invoiceFormButtons = {
  save: (
    onClick: () => void,
    disabled: boolean,
    additionalAttributes: React.ButtonHTMLAttributes<HTMLButtonElement>,
  ) => (
    <button
      onClick={onClick}
      className="invoiceEditor-saveBtn"
      disabled={disabled}
      {...additionalAttributes}
    >
      Save
    </button>
  ),
  moveToReady: (
    onClick: () => void,
    disabled: boolean,
    additionalAttributes: React.ButtonHTMLAttributes<HTMLButtonElement>,
  ) => (
    <button
      onClick={onClick}
      disabled={disabled}
      {...additionalAttributes}
      className="invoiceEditor-moveToReadyBtn"
    >
      Move to Ready
    </button>
  ),
  moveToArchive: (
    onClick: () => void,
    disabled: boolean,
    additionalAttributes: React.ButtonHTMLAttributes<HTMLButtonElement>,
  ) => (
    <button
      onClick={onClick}
      disabled={disabled}
      {...additionalAttributes}
      className="invoiceEditor-moveToArchiveBtn"
    >
      Move to Archive
    </button>
  ),

   moveToUnArchive: (
    onClick: () => void,
    disabled: boolean,
    additionalAttributes: React.ButtonHTMLAttributes<HTMLButtonElement>,
  ) => (
    <button
      onClick={onClick}
      disabled={disabled}
      {...additionalAttributes}
      className="invoiceEditor-moveToArchiveBtn"
    >
      Move to Unarchive
    </button>
  ),
};
